import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes, AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
export const id_archivedKey = "1.3.6.1.4.1.311.21.13";
let ArchivedKey = class ArchivedKey {
    constructor(value = new ArrayBuffer(0)) {
        this.value = value;
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.Any })
], ArchivedKey.prototype, "value", void 0);
ArchivedKey = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], ArchivedKey);
export { ArchivedKey };
